import UsersActionsTable from './NotificationsTable';

export default UsersActionsTable;
